"use client";

import { useSyncExternalStore } from "react";

// Empty subscribe function - no external updates to listen for
const emptySubscribe = (_onStoreChange: () => void): (() => void) => () => {};

/**
 * Hydration detection using useSyncExternalStore (React 18+ pattern).
 * Server/hydration: returns false, Client after hydration: returns true
 *
 * @returns true if component is hydrated on the client, false during SSR/hydration
 *
 * @example
 * ```tsx
 * const hydrated = useHydrated()
 * if (!hydrated) {
 *   return <Skeleton />
 * }
 * ```
 */
export const useHydrated = () => {
  return useSyncExternalStore(emptySubscribe, _temp, _temp2);
};
function _temp() {
  return true;
}
function _temp2() {
  return false;
}